// extracted by mini-css-extract-plugin
export default {"view":"TableView_view__qMWii","tabs":"TableView_tabs__OABXL","active":"TableView_active__7Ko2r","inactive":"TableView_inactive__E768b"};